import { ThemeSwitcher } from "@/components/theme-switcher";
import { UserNav } from "@/components/admin-panel/user-nav";
import { SheetMenu } from "./sheet-menu";
import { HEADER_ID } from "../../constants/header-id";
import CartButton from "./cart-button";
export function Navbar() {
  return (
    <header className="sticky top-0 z-10 w-full bg-background/95 shadow-sm backdrop-blur-sm supports-backdrop-filter:bg-background/60 dark:shadow-secondary">
      <div className="mx-4 sm:mx-8 flex h-fit min-h-14 items-center">
        <SheetMenu />

        <div className="flex grow items-center">
          <div id={HEADER_ID} className="w-full" />
        </div>

        <div className="flex items-center gap-2">
          <CartButton />

          <ThemeSwitcher />

          <UserNav />
        </div>
      </div>
    </header>
  );
}
